import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { getPrimaryLanguage } from "@krea/customer-features/utils";
import { bankIDTranslations } from "@krea/shared/features/bankID/translations";
// Disable localStorage usage for language detection and rely on cookies instead
// localStorage is not available in some browsers some times and causes crashes.
const languageDetector = new LanguageDetector(null, {
  caches: ["cookie"],
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        customerWeb: require("./translations/customer/en.json"),
        common: require("@krea/customer-features/translations/common/en.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.en,
      },
      sv: {
        customerWeb: require("./translations/customer/sv.json"),
        common: require("@krea/customer-features/translations/common/sv.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.sv,
      },
      fi: {
        customerWeb: require("./translations/customer/fi.json"),
        common: require("@krea/customer-features/translations/common/fi.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.fi,
      },
    },
    lng: getPrimaryLanguage(),
    fallbackLng: "en",
    supportedLngs: ["sv", "en", "fi"],
    ns: ["customerWeb", "common", bankIDTranslations.namespace],
    defaultNS: ["customerWeb", bankIDTranslations.namespace, "common"],
    fallbackNS: ["customerWeb", bankIDTranslations.namespace, "common"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "ul", "li", "a"],
    },
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
